import Vue from 'vue'
import Router from 'vue-router'


// const originalPush = Router.prototype.push;
// const originalReplace = Router.prototype.replace;

// Router.prototype.push = function push(location, onResolve, onReject) {
//     if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//     return originalPush.call(this, location).catch(err => err)
// }
// Router.prototype.replace = function push(location, onResolve, onReject) {
//   if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
//   return originalReplace.call(this, location).catch(err => err)
// }

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    name:'home',
    component: () => import('@/views/home/index.vue'),
    meta: {
      metaInfo: {
          title: "大湾区管弦乐团",
          keywords: "大湾区管弦乐团",
          description: "李楠",
          ogtitle:"大湾区管弦乐团",
          ogimage:"http://www.gbphil.com:5000/UploadFile/20240125/個人宣傳照片 01_110404.jpeg",
          ogurl:"http://www.gbphil.com/",
      }
    }
  },
  {
    path: '/list/:id',
    name:'list',
    component: () => import('@/views/list/index.vue'),
  },
  {
    path: '/musician/guestconductor/:pcode',
    name:'musician',
    component: () => import('@/views/musician/guestconductor.vue'),
  },
  {
    path: '/musician/listmusicians/:pcode',
    name:'musician',
    component: () => import('@/views/musician/listmusicians.vue'),
  },
  {
    path: '/musician/musicdirector/:pcode',
    name:'musician',
    component: () => import('@/views/musician/musicdirector.vue'),
  },
  {
    path: '/musician/musicianinresidence/:pcode',
    name:'musician',
    component: () => import('@/views/musician/musicianinresidence.vue'),
  },
  {
    path: '/container/:id',
    name:'container',
    component: () => import('@/views/container/index.vue'),
  },
]

const createRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  mode:'hash',
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

// 全局前置守卫
// router.beforeEach((to, from, next) => {
//   if (to.meta.metaInfo) {
//     store.commit("metaModule/CHANGE_META_INFO", to.meta.metaInfo)
//   }
//   next()
// })

export default router
